<template>
  <div>
    <section-title
      class="mt-4"
      content="Presentación de Periodos"
      :has-line="true"
    />
    <div class="period-selection-container ml-1 mb-5">
      <label class="color-black font-18 mt-1 mr-3">Periodo:</label>
      <div
        class="period-selection-container__section"
        :class="[{ finalized: this.completedPeriod }]"
      >
        <div
          v-for="(p, index) in getPeriods"
          :key="'period-selection' + index"
          class="period-selection-container__period"
          :class="[
            {
              disabled: p.disabled && !p.completed && !p.active,
              completed: p.completed,
              active: p.active && !p.completed,
            },
          ]"
          @click="onSelectPeriodHandler(p)"
        >
          <span class="d-block color-gray-6 font-14 font-weight-bold">
            {{ p.month }}
          </span>
          <span class="color-gray-6 font-14">
            {{ p.year }}
          </span>
          <div v-if="p.completed" class="period-finish">
            <div class="d-flex align-items-center mr-2">
              <div
                v-if="p.completed"
                class="dot cursor-pointer bg-white"
                @click="extraExpanded = !extraExpanded"
              >
                <em class="title-icon fa fa-check color-green" />
              </div>
              <span class="mt-0">Finalizado</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import moment from 'moment';
import 'moment/locale/es-do';

const MONTH_FORMAT = 'MMM';
const YEAR_FORMAT = 'YYYY';
const LIMIT_MONTHS = 12;
const INITIAL_MONTH = 5;

export default {
  name: 'PeriodNavigation',
  components: {
    SectionTitle,
  },
  props: {
    currentPeriod: {
      type: Date,
      required: true,
    },
    initialPeriod: {
      type: Date,
      required: true,
    },
    disabledPeriods: {
      type: Array,
      default: () => [],
    },
    completedPeriod: {
      type: Date,
      default: () => null,
    },
    extendPeriod: {
      type: Boolean,
      default: () => false,
    },
  },
  data: () => ({
    currentPeriodModel: null,
  }),
  computed: {
    getPeriods() {
      const initialPeriod = moment().set({
        year: this.initialPeriod.getFullYear(),
        month: INITIAL_MONTH,
      });
      const periods = [];
      const months = this.extendPeriod ? LIMIT_MONTHS + 1 : LIMIT_MONTHS;
      for (let index = 1; index <= months; index++) {
        const p = moment(initialPeriod).add(index, 'month');
        periods.push({
          id: index,
          date: p,
          period: {
            year: p.year(),
            monthNumber: p.month() + 1,
          },
          month: p.format(MONTH_FORMAT).toUpperCase(),
          year: p.format(YEAR_FORMAT),
          active:
            this.formatDateToEval(
              moment(this.currentPeriodModel || this.currentPeriod)
            ) == this.formatDateToEval(p),
          disabled: this.isDisabled(p, index),
          completed:
            this.formatDateToEval(moment(this.completedPeriod)) ==
            this.formatDateToEval(p),
        });
      }
      return periods;
    },
    disabledPeriodsFormatted() {
      return this.disabledPeriods.map((s) => this.formatDateToEval(s));
    },
    hasActivePeriod() {
      return this.getPeriods.some((x) => x.active);
    },
  },
  watch: {
    currentPeriod() {
      this.currentPeriodModel = this.currentPeriod;
    },
  },
  methods: {
    formatDateToEval(value) {
      return moment(value).format(`${MONTH_FORMAT} ${YEAR_FORMAT}`);
    },
    isDisabled(period) {
      return this.disabledPeriodsFormatted.includes(
        this.formatDateToEval(period)
      );
    },
    onSelectPeriodHandler({ disabled, period }) {
      if (this.disabledPeriods && disabled) {
        return;
      }
      this.$emit('input', period);
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/shared/scss/config/colors.scss';

.period-selection-container {
  display: flex;
  justify-content: center;
  align-items: center;
  &__section {
    display: flex;
    flex-flow: row wrap;
    flex: 1;
  }
  &__period {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: center;
    align-items: center;
    span {
      user-select: none;
    }
    span:last-child {
      margin-top: -4px;
    }
    &.active {
      padding: 2px 0px;
      background: map-get($colors, 'orange');
      span {
        color: map-get($colors, 'white') !important;
      }
      border-radius: 30px;
    }
    &.disabled {
      span {
        color: map-get($colors, 'gray-5') !important;
      }
    }
    &.completed {
      padding: 2px 0px;
      background: map-get($colors, 'orange') !important;
      span {
        color: map-get($colors, 'white') !important;
      }
      border-radius: 20px;
      .period-finish {
        background: map-get($colors, 'green');
        color: map-get($colors, 'white');
        border-radius: 50px;
        position: absolute;
        margin-top: 80px;
        padding: 2px 10px;
        span {
          font-size: 14px;
          font-weight: bold;
          margin-top: 1px !important;
        }
      }
    }
  }
}
.finalized {
  .period-selection-container__period:not(.completed) {
    span {
      color: map-get($colors, 'black');
    }
  }
}
.dot {
  box-shadow: 0px 3px 6px #00000029;
  margin: 2px;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  border-style: solid;
  border-width: 1px;
  display: inline-block;
  margin-right: 10px;
}

.title-icon {
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1px;
  font-size: 12px;
}

.dot.green {
  background-color: #2db782;
}

@media only screen and (max-width: 768px) {
  .period-finish {
    bottom: -69px !important;
  }
}
</style>
